import { render, staticRenderFns } from "./modelManage.vue?vue&type=template&id=7473e714&scoped=true"
import script from "./modelManage.vue?vue&type=script&lang=js"
export * from "./modelManage.vue?vue&type=script&lang=js"
import style0 from "./modelManage.vue?vue&type=style&index=0&id=7473e714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473e714",
  null
  
)

export default component.exports